import type { ApprovalRequestType } from "@/common/artemis-sdk";
import type { ApprovalRiskLevel, ApprovalStatus } from "@/common/model";
import {
	createLabelTag,
	createStatusBadge,
	type TagStatus,
} from "../status-pill";

const statusColorMap: Record<ApprovalStatus, TagStatus> = {
	APPROVED: "success",
	CONSUMED: "success",
	EXPIRED: "error",
	INVALIDATED: "error",
	PENDING: "warning",
	REJECTED: "error",
};

export const ApprovalStatusLabelMap: Record<ApprovalStatus, string> = {
	APPROVED: "Approved",
	CONSUMED: "Consumed",
	EXPIRED: "Expired",
	INVALIDATED: "Invalidated",
	PENDING: "Pending Approval",
	REJECTED: "Rejected",
};

export const approvalTypeLabelMap: Record<ApprovalRequestType, string> = {
	CHANGE_REQUEST: "Change Request",
	CREDENTIAL_REQUEST: "Credentials Request",
};

export const ApprovalStatusBadge = createStatusBadge(
	statusColorMap,
	ApprovalStatusLabelMap,
	{ pulseWhen: ["PENDING"] },
);

const riskColorMap: Record<ApprovalRiskLevel, TagStatus> = {
	CRITICAL: "critical",
	HIGH: "error",
	LOW: "success",
	MEDIUM: "warning",
};

export const ApprovalRiskLabelMap: Record<ApprovalRiskLevel, string> = {
	CRITICAL: "Critical",
	HIGH: "High",
	LOW: "Low",
	MEDIUM: "Medium",
};

export const ApprovalRiskBadge = createStatusBadge(
	riskColorMap,
	ApprovalRiskLabelMap,
);

export const ApprovalTypeBadge = createLabelTag(approvalTypeLabelMap);
